import { API } from 'aws-amplify'
import {
  REACT_APP_BASE_KEY,
  REACT_APP_BASE_NAME,
  REACT_APP_CLIENT_NAME
} from '../config/settings/environment'
import TruckModel from '../store/models/truck'
import TankerModel from '../store/models/tanker'
import StatusModel from '../store/models/status'
import GroupsEfficiencyModel from '../store/models/groupsEfficiency'

export const getTrucksAWS = () => {
  const paths = {
    amsa: '/fuel_levels/fuel_level_truck',
    anglo: '/fuel_levels/fuel_level_truck',
    zaldivar: '/v2/fuel_levels/fuel_level_truck'
  }
  const path = paths[REACT_APP_CLIENT_NAME] || '/v2/fuel_levels/fuel_level_truck'

  const init = {
    headers: {
      'x-api-key': REACT_APP_BASE_KEY
    },
    response: true
  }

  return API.get(REACT_APP_BASE_NAME, path, init)
    .then(response => {
      const rawTrucks = response.data
      const trucks = rawTrucks.map(truck => new TruckModel().fromV1(truck))
      return trucks
    })
    .catch(error => {
      console.error('[API][GET][TRUCKS] ' + JSON.stringify(error))
    })
}

export const getTankersAWS = () => {
  const paths = {
    amsa: '/fuel_levels/fuel_level_tanker',
    anglo: '/fuel_levels/fuel_level_tanker',
    zaldivar: '/v2/fuel_levels/fuel_level_tanker'
  }
  const path = paths[REACT_APP_CLIENT_NAME] || '/v2/fuel_levels/fuel_level_tanker'

  const init = {
    headers: {
      'x-api-key': REACT_APP_BASE_KEY
    },
    response: true
  }

  return API.get(REACT_APP_BASE_NAME, path, init)
    .then(response => {
      const rawData = response.data
      const tankers = rawData.map(item => new TankerModel().fromV1(item))
      return tankers
    })
    .catch(error => {
      console.error('[API][GET][TANKERS] ' + JSON.stringify(error))
    })
}

export const getServicesStateAWS = () => {
  const paths = {
    amsa: '/fuel_levels/alerts',
    anglo: '/fuel_levels/alerts',
    zaldivar: '/v2/fuel_levels/alerts'
  }
  const path = paths[REACT_APP_CLIENT_NAME] || '/v2/fuel_levels/alerts'

  const init = {
    headers: {
      'x-api-key': REACT_APP_BASE_KEY
    },
    response: true
  }

  return API.get(REACT_APP_BASE_NAME, path, init)
    .then(response => {
      const rawData = response.data
      return new StatusModel().fromV1(rawData)
    })
    .catch(error => {
      console.error('[API][GET][SERVICES] ' + JSON.stringify(error))
    })
}

// GET fuel_levels/last_modification
export const getLastUpdateAWS = () => {
  const paths = {
    amsa: '/fuel_levels/last_modification',
    anglo: '/fuel_levels/last_modification',
    zaldivar: '/v2/fuel_levels/last_modification'
  }
  const path = paths[REACT_APP_CLIENT_NAME] || '/v2/fuel_levels/last_modification'

  const init = {
    headers: {
      'x-api-key': REACT_APP_BASE_KEY
    },
    response: true
  }

  return API.get(REACT_APP_BASE_NAME, path, init)
    .then(response => {
      return response.data
    })
    .catch(error => {
      console.error('[API][GET][LAST_UPDATE] ' + JSON.stringify(error))
    })
}

export const getHistoryDispach = () => {
  const paths = {
    amsa: '/fuel_levels/dispatch/available',
    anglo: '/v2/fuel_levels/dispatch/available',
    zaldivar: '/v2/fuel_levels/dispatch/available'
  }
  const path = paths[REACT_APP_CLIENT_NAME] || '/v2/fuel_levels/dispatch/available'

  const init = {
    headers: {
      'x-api-key': REACT_APP_BASE_KEY
    },
    response: true
  }

  return API.get(REACT_APP_BASE_NAME, path, init)
    .then(response => {
      const rawData = response.data
      const dataProcess = []
      for (const data of rawData) {
        const month = data.month < 10 ? `0${data.month}` : data.month
        data.value = `${month}/${data.year}`
        dataProcess.push(data)
      }
      dataProcess.push({ value: 'actual' })
      return dataProcess
    })
    .catch(error => {
      console.error('[API][GET][DISPATCH] ' + JSON.stringify(error))
    })
}

export const getEfficiencyStadistics = (month = null, year = null) => {
  const paths = {
    amsa: '/fuel_levels/dispatch_v1',
    anglo: '/fuel_levels/dispatch_v1',
    zaldivar: '/v2/fuel_levels/dispatch'
  }
  const basePath = paths[REACT_APP_CLIENT_NAME] || '/v2/fuel_levels/dispatch'
  const path = month && year ? `${basePath}?month=${month}&year=${year}` : basePath

  const init = {
    headers: {
      'x-api-key': REACT_APP_BASE_KEY
    },
    response: true
  }

  return API.get(REACT_APP_BASE_NAME, path, init)
    .then(response => {
      const rawData = response.data
      const groupNames = Object.keys(rawData)
      const groups = groupNames.map(groupName => {
        if (groupName !== 'month' && groupName !== 'year') {
          const groupId = groupName.replace('g', '')
          return new GroupsEfficiencyModel().fromV1(groupId, rawData[groupName], rawData.month, rawData.year)
        }
      })
      return groups
    })
    .catch(error => {
      console.error('[API][GET][DISPATCH] ' + JSON.stringify(error))
    })
}
